import request from "@/utils/request";

// 获取表头
export function getTableHead(data) {
  return request({
    url: "/public/sqlTemplate/queryFields?templateCode=" + data,
    method: "get",
    data: data
  });
}
// 获取表数据
export function getList(data) {
  return request({
    url: "/ums/public/query",
    method: "post",
    data: data
  });
}
// 获取表头已选择的数据
export function getTableSetHead(data) {
  return request({
    url: "/public/publicUserListCustomField/query?templateCode=" + data,
    method: "get",
    data: data
  });
}
// 保存表头已选择的数据
export function saveTableSetHead(data) {
  return request({
    url: "/public/publicUserListCustomField/save",
    method: "post",
    data: data
  });
}
// pdm通用查询模板获取表数据
export function getPdmTemplateList(data) {
  return request({
    url: "/pdm/public/query",
    method: "post",
    data: data
  });
}
// 查询出来的数据表格获取图片列表的接口
export function getImgList(data) {
  return request({
    url: "/pdm/commonAttachment/queryCommonAttachmentByColorId?colorId=" + data,
    method: "get",
    data: data
  });
}

// 查询模板列表通用接口
export function getPdmList(data) {
  return request({
    url: "/pdm/pdmPlateOrder/queryList",
    method: "post",
    data: data
  });
}

// 通过版单ID查询操作人记录
export function queryOperation(data) {
  return request({
    url: "/pdm/pdmBusinessOperation/queryOperation?id=" + data,
    method: "get",
    data: data
  });
}

// 通过版单ID查询套版信息
export function queryOverprintPlate(data) {
  return request({
    url: "/pdm/pdmRegistrationConfirmation/queryOverprintPlate?id=" + data,
    method: "get",
    data: data
  });
}
// 花稿设计列表页查询接口
export function getFlowerDesignList(data) {
  return request({
    url: "/pdm/pdmFlowerDesign/queryList",
    method: "post",
    data: data
  });
}
// 通过供应商CODE获取联系信息
export function getSupplierContacts(data) {
  return request({
    url: "/pdm/mdSupplier/querySupplyInformation/" + data,
    method: "get",
    data: data
  });
}

// 通过供应商ID获取SKU信息
export function getMaterialMasterDataSku(data) {
  return request({
    url: "/pdm/materialMasterData/getMaterialMasterDataSku?id=" + data,
    method: "get"
  });
}
// 通过单据ID查看驳回记录
export function getRejectRecordList(data) {
  return request({
    url: "/pdm/pdmFlowerDesign/rejectRecord?id=" + data,
    method: "get",
    data: data
  });
}

// 查询一个组下的数据字典
export function queryByGroupIdentification(data) {
  return request({
    url: "/pdm/commonDictionary/queryByGroupIdentification/" + data,
    method: "get"
  });
}

// 根据物料编码查询物料简要信息
export function queryMaterialByCode(data) {
  return request({
    url: "/pdm/pdmSecondaryProcess/queryMaterialByCode/" + data,
    method: "get"
  });
}